import Http from "../services/http";

import { ApiRoutes } from "../common/apiRoutes";

const cloneBookingAPI = (data: any) => {
    return Http.post(ApiRoutes.cloneBooking, data);
};
const editBookingAPI = (id:any,data: any) => {
    return Http.put(`booking/update/${id}`, data);
};

const cloneBookAPI = (data: any) => {
    return Http.post(ApiRoutes.cloneBook, data);
};

export {
    editBookingAPI,
    cloneBookingAPI,
    cloneBookAPI
}